import * as i0 from "@angular/core";
var CipherCommunicatorService = /** @class */ (function () {
    function CipherCommunicatorService() {
    }
    CipherCommunicatorService.prototype.encryptRequest = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(options);
            reject();
            return;
        });
    };
    CipherCommunicatorService.prototype.decryptResponse = function (encryptedResponse, _options) {
        return new Promise(function (resolve) {
            resolve(encryptedResponse);
            return;
        });
    };
    CipherCommunicatorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CipherCommunicatorService_Factory() { return new CipherCommunicatorService(); }, token: CipherCommunicatorService, providedIn: "root" });
    return CipherCommunicatorService;
}());
export { CipherCommunicatorService };
